import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const STEPS = [
  {
    emoji: '👋',
    title: 'Velkommen til Tag Team',
    text: 'Træt af at få skældt ud over glemte opgaver? Med Tag Team gøres både indkøb, todo\'s og opgaver nemme og sjove at huske.',
  },
  {
    emoji: '👤',
    title: 'For dig selv, og din partner',
    text: 'Få styr på dine daglige opgaver, eller få din partner op af stolen og sørg for at tingene bliver gjort til tiden.',
  },
  {
    emoji: '📨',
    title: 'Send opgaver til hinanden',
    text: 'Når din partner skal huske noget, så send dem en opgave. Sæt deadline og pointværdi. Jo hurtigere de løser den, jo flere point — og kærlighedspoint til jer begge.',
  },
  {
    emoji: '🎁',
    title: 'Tilføj belønninger',
    text: 'Sæt en belønning på opgaven — en is, massage, god middag. Vis den som motivation eller skjul den som overraskelse, der afsløres når opgaven er løst.',
  },
  {
    emoji: '🚀',
    title: 'Klar til at komme i gang?',
    text: 'Lad os hente lidt point hjem. Tag Team starter solo — eller find din partner i indstillingerne, så I kan spille sammen.',
  },
];

export function WelcomeOnboarding({ theme, onClose }) {
  const [step, setStep] = useState(0);
  const isLast = step === STEPS.length - 1;
  const current = STEPS[step];

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: theme.bg,
      zIndex: 300,
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* Skip button */}
      <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        padding: 16,
      }}>
        <button onClick={onClose} style={{
          background: 'transparent',
          border: 'none',
          color: theme.textMuted,
          fontSize: 13,
          fontWeight: 500,
          cursor: 'pointer',
        }}>Spring over</button>
      </div>

      {/* Body */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px 32px',
        textAlign: 'center',
        maxWidth: 480,
        margin: '0 auto',
      }}>
        <div style={{ fontSize: 64, marginBottom: 24 }}>{current.emoji}</div>
        <h1 style={{
          margin: 0,
          fontSize: 26,
          fontWeight: 800,
          letterSpacing: -0.5,
          color: theme.text,
        }}>{current.title}</h1>
        <p style={{
          margin: '14px 0 0',
          fontSize: 15,
          color: theme.textMuted,
          lineHeight: 1.55,
        }}>{current.text}</p>
      </div>

      {/* Footer */}
      <div style={{ padding: '20px 24px 32px' }}>
        {/* Step dots */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 6,
          marginBottom: 20,
        }}>
          {STEPS.map((_, i) => (
            <div key={i} style={{
              width: i === step ? 20 : 6,
              height: 6,
              borderRadius: 3,
              background: i === step ? theme.coral : theme.border,
              transition: 'all 0.2s',
            }} />
          ))}
        </div>

        <div style={{
          display: 'flex',
          gap: 8,
          maxWidth: 480,
          margin: '0 auto',
        }}>
          <button
            onClick={() => setStep(step - 1)}
            disabled={step === 0}
            style={{
              flex: 1,
              padding: '14px 16px',
              borderRadius: 12,
              border: `1px solid ${theme.border}`,
              background: 'transparent',
              color: theme.textMuted,
              fontSize: 14,
              fontWeight: 600,
              cursor: step === 0 ? 'default' : 'pointer',
              opacity: step === 0 ? 0.4 : 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 6,
            }}
          >
            <ChevronLeft size={16} /> Tilbage
          </button>
          <button
            onClick={() => isLast ? onClose() : setStep(step + 1)}
            style={{
              flex: 2,
              padding: '14px 16px',
              borderRadius: 12,
              border: 'none',
              background: theme.coral,
              color: 'white',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 6,
            }}
          >
            {isLast ? 'Lad os starte' : 'Næste'}
            {!isLast && <ChevronRight size={16} />}
          </button>
        </div>
      </div>
    </div>
  );
}
